import { DEFAULT_PARTNER } from '../constants/Configs';
import { LocalStorageService } from '../services/LocalStorageService';
import { EditModeEnum } from '../components/elements/enums/EditModeEnum'
import { Auth } from './Auth';
import ErrorType from '../constants/Errors/ErrorTypes';
import { LanguageService } from './LanguageService'
import { Browser } from './helpers/Browser'
import { UAParser } from 'ua-parser-js';
import PopupEnum from '../components/base/PopupEnum';
import MobileRoutesEnum from '../components/base/MobileRoutesEnum';
import NewOfferMenuEnum from '../components/myProfile/offers/bonuses/NewOfferMenuEnum';
import DepositEnum from '../components/myProfile/payments/enums/DepositEnum';
import { RoutePath } from '../constants/SitePaths';
const urlsToSkipWhileLoggedIn = ['/popup/registration', '/popup/login', 'modal-registration', 'modal-login']

const Utils = {
    resizeTimeOut: null,
    findParentElemntByClassName(el, cls) {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
    },
    isDefaultPartner(partnerId) {
        return DEFAULT_PARTNER === partnerId;
    },
    formatString(formatted) {
        for (var i = 1; i < arguments.length; i++) {
            var regexp = new RegExp('\\{' + i + '\\}', 'gi');
            formatted = formatted.replace(regexp, arguments[i]);
        }
        return formatted;
    },

    getDeviceNameFromUserAgent() {
        const parser = new UAParser();
        const osName = parser.getOS().name;
        const browserName = parser.getBrowser().name;
        const { vendor, model, type } = parser.getDevice();
        return `${model ? model + '-' : ''}${vendor ? vendor + '-' : ''}${type ? (type === 'mobile' ? 'Web' : '') + type + '-' : ''}${osName}-${browserName?.replace(/\s/g, '')}`
    },

    getTemplateAreasFromArray(gridItems, rowHeight, contentAutoHeightList, rowsCount) {
        const gridTemplateString = [];
        const templateRows = [];
        let rowsCountArray = [];
        for (let i = 0; i < rowsCount; i++) {
            rowsCountArray.push('.')
        }

        // let c = 0;
        gridItems.forEach((it, c) => {
            let tempx = it.x;
            let deltaI = 0;
            for (let i = it.y; i < it.h + it.y + deltaI; i++) {
                if (!gridTemplateString[i]) gridTemplateString[i] = [...rowsCountArray];
                // if element is out of range move to next available line
                if (it.x >= rowsCount) {
                    if (!deltaI) {
                        deltaI = gridTemplateString.length - i;
                        tempx = 0;
                        i = gridTemplateString.length;
                    }
                    if (!gridTemplateString[i]) gridTemplateString[i] = [...rowsCountArray];
                }

                let isPlaceBusy = false;
                for (let j = tempx; j < tempx + it.w; j++) {
                    // if elements is too long, cut at the end of line
                    if (j >= rowsCount) break;

                    // if elements place already filled
                    if (!deltaI && j <= rowsCount && gridTemplateString[i][j] !== '.' && !isPlaceBusy) {
                        isPlaceBusy = true
                        deltaI = gridTemplateString.length - i;
                        tempx = 0;
                        i = gridTemplateString.length;
                        if (!gridTemplateString[i]) gridTemplateString[i] = [...rowsCountArray];
                    }

                    gridTemplateString[i][j] = String.fromCharCode(97 + c);
                    const isAutoHeight = contentAutoHeightList.some(item => item === it.content);
                    if (!templateRows[i] || isAutoHeight) {
                        isAutoHeight ? templateRows[i] = 'auto' : templateRows[i] = rowHeight + 'px'
                    }
                }
            }
        })

        // fill all missing lines with dots
        for (let i = 0; i < gridTemplateString.length; i++) {
            if (!gridTemplateString[i]) gridTemplateString[i] = [...rowsCountArray];
        }
        return {
            gridTemplateRowsCount: gridTemplateString.length,
            gridTemplateString: gridTemplateString.reduce((acc, curr) => acc + (acc ? '\n\r' : '') + `"${curr.join(' ')}"`, ''),
            templateRows
        }
    },

    // Function to adjust grid items for mobile layout
    adjustItemsForMobile(items) {
        let lastY = 0
        return items.map(item => {
            // Check if the item fits on the current line
            let currentDelta = 0;
            let currentX = item.x;
            if (item.x >= 2) {
                currentX = 0; // Move to the next line
                currentDelta = lastY - item.y;
            }
            lastY = item.y + item.h + currentDelta;
            // Update the item's left position
            return {
                ...item,
                x: currentX,
                w: Math.min(currentX + item.w, 2),
                y: item.y + currentDelta,
                h: item.h
            };
        });
    },

    getYoutubeId(url) {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);

        return (match && match[2].length === 11)
            ? match[2]
            : null;
    },

    addCdnUrl(cdnUrl, url) {
        if (!cdnUrl) {
            return url;
        }
        cdnUrl = cdnUrl[cdnUrl?.length - 1] !== '/' ? cdnUrl + '/' : cdnUrl
        url = url && !Browser.isAbsoluteURL(url) && url[0] === '/' ? url.slice(1) : url
        return Browser.isAbsoluteURL(url) ? url : cdnUrl + url;
    },

    urlExtensionCheck(url, extension) {
        const reg = new RegExp("\\." + extension + "(?:\\?|$)");
        return reg.test(url);
    },

    validatePhoneNumber(str) {
        const reg = /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;     // +1 (615) 243-5172
        return reg.test(str);
    },

    validateEmailAddress(str) {
        const reg = /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})?$/;     // hello@uibakery.io
        return reg.test(str);
    },

    checkIfLinkActualForLoggedinUsers(url) {
        const promotionUrl = url || '';
        return !Auth.isAuthenticated() || !urlsToSkipWhileLoggedIn.filter(u => promotionUrl.indexOf(u) >= 0).length;
    },

    toCamelCase(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    },

    toCNPCamelCase(string) {
        return string === 'CNP' ? string.toLowerCase() :  string.charAt(0).toLowerCase() + string.slice(1);
    },

    getNumberEvenValue(number) {
        const integerNumber = Math.ceil(number);
        return integerNumber % 2 === 0 ? integerNumber : integerNumber + 1;
    },

    scrollToTop(element, options = {}) {
        const defaultOpions = { top: 0, left: 0, behavior: 'smooth' }
        options = { ...defaultOpions, ...options }
        if (element) {
            const elementRect = element.getBoundingClientRect();
            const absoluteElementTop = elementRect.top + window.scrollY;
            options.top = absoluteElementTop - options.top;
        }
        window.scrollTo(options);
    },

    objectToQueryParams(obj) {
        let string = '?';
        for (var key in obj) {
            if (string !== '?' && !Array.isArray(obj[key])) {
                string += '&';
            }
            string += Array.isArray(obj[key]) ? obj[key].reduce((acc, item) => acc + key + "=" + item + "&", '&').slice(0, -1) : key + "=" + obj[key];
        }
        return string;
    },

    parseQuery(queryString) {
        if (typeof queryString !== 'string') {
            return null;
        }
        var query = {};
        var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
        return query;
    },
    objectToQueryParamsWithModel(obj, modelName) {
        let string = '?';
        for (var key in obj) {
            if (string !== '?') {
                string += '&';
            }
            string += modelName + "." + key + "=" + obj[key];
        }
        return string;
    },

    formatCurrency(currency, fraction = 2, maximumFraction = 0) {
        const currencyFormat = new Intl.NumberFormat('en-US', { minimumFractionDigits: fraction, maximumFractionDigits: maximumFraction || fraction }).format(currency).replace(/,/g, ' ');
        return currencyFormat === 'NaN' ? '' : currencyFormat;
    },

    currencyMaxFraction(currency, maximumFraction = 0) {
        const currencyFormat = new Intl.NumberFormat('en-US', { maximumFractionDigits: maximumFraction }).format(currency).replace(/,/g, ' ');
        return currencyFormat === 'NaN' ? '' : currencyFormat;
    },


    checkTimeZone(z) {
        return z > 0 ? "-" + z : z * -1;
    },

    checkTimeZoneWithPlus(z) {
        return z > 0 ? "-" + z : "+" + z * -1;
    },

    getTimeZone() {
        const date = new Date();
        let timeZone = date.getTimezoneOffset() / 60;
        return this.checkTimeZone(timeZone);
    },

    getOptions(objectList) {
        return objectList ? objectList.map(object => {
            return {
                value: object.id,
                label: object.name
            }
        }) : [];
    },

    getISOOptions(objectList) {
        return objectList ? objectList.map(object => {
            return {
                value: object.id,
                label: `${object.isoCode} - ${object.name}`
            }
        }) : [];
    },

    getISOProfileOptions(objectList) {
        return objectList ? objectList.map(object => {
            return {
                value: object.id,
                label: `${object.isoCode || object.countryCode} - ${object.name}`
            }
        }) : [];
    },


    removeOverflowHidden() {
        if (document.getElementsByTagName('html')[0].classList.contains('ovfh')) {
            document.getElementsByTagName('html')[0].classList.remove('ovfh');
        }
    },

    addOverflowHidden() {
        if (!document.getElementsByTagName('html')[0].classList.contains('ovfh')) {
            document.getElementsByTagName('html')[0].classList.add('ovfh');
        }
    },

    removeOverflowHiddenSecondary() {
        if (document.getElementsByTagName('html')[0].classList.contains('ovfh-secondary')) {
            document.getElementsByTagName('html')[0].classList.remove('ovfh-secondary');
            // if (document.getElementsByTagName('html')[0].classList.contains('ovfh-incative')) {
            //     document.getElementsByTagName('html')[0].classList.remove('ovfh-incative');
            //     document.getElementsByTagName('html')[0].classList.add('ovfh');
            // }
        }
    },

    getTokenFromLocalStorage() {
        return LocalStorageService.get('_ga_anl_cf3q');
    },

    setTokenInLocalStorage(token) {
        LocalStorageService.set('_ga_anl_cf3q', token);
    },

    addOverflowHiddenSecondary() {
        if (!document.getElementsByTagName('html')[0].classList.contains('ovfh-secondary')) {
            document.getElementsByTagName('html')[0].classList.add('ovfh-secondary');
            // if (document.getElementsByTagName('html')[0].classList.contains('ovfh')) {
            //     document.getElementsByTagName('html')[0].classList.remove('ovfh');
            //     document.getElementsByTagName('html')[0].classList.add('ovfh-incative');
            // }
        }
    },

    getCurrenciesOptions(objectList) {
        return objectList ? objectList.map(object => {
            return {
                value: object.id,
                label: object.id
            }
        }) : [];
    },

    checkAbsolutePath(url) {
        // return /^https?:\/\//.test(url) ? true : false;
        return url && url[0] !== '/' ? true : false;
    },

    fixAbsoluteUrl(url) {
        return /\/\//.test(url) ? url : '//' + url;
    },

    getWindowSize() {
        const w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0],
            x = w.innerWidth || e.clientWidth || g.clientWidth;
        // y = w.innerHeight || e.clientHeight || g.clientHeight;
        return x;
    },

    isSmallDesktop() {
        return Utils.getWindowSize() < 1200;
    },

    isTablet() {
        return Utils.getWindowSize() < 1024;
    },

    isMobile() {
        return Utils.getWindowSize() <= 767;
    },

    isSmallMobile() {
        return Utils.getWindowSize() <= 400;
    },


    isObject(item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
    },

    mergeDeep(target, source) {
        let output = Object.assign({}, target);
        if (Utils.isObject(target) && Utils.isObject(source)) {
            Object.keys(source).forEach(key => {
                if (Utils.isObject(source[key])) {
                    if (!(key in target))
                        Object.assign(output, { [key]: source[key] });
                    else
                        output[key] = Utils.mergeDeep(target[key], source[key]);
                } else {
                    Object.assign(output, { [key]: source[key] });
                }
            });
        }
        return output;
    },


    isPreviewMode() {
        return window.self !== window.top
    },

    setPreviewMode() {
        LocalStorageService.set("mode", "postmessage");
    },

    resetPreviewMode() {
        return LocalStorageService.remove('mode');
    },


    createFormAndSubmit(id, model, url, method = 'POST', target = '_blank') {
        //Creating form
        let form = document.createElement("form");
        form.setAttribute("id", id);
        form.classList.add('tb--hide')
        form.setAttribute('validated', true);
        form.setAttribute('accept-charset', "utf-8");
        form.method = method;
        form.action = url;
        form.target = target;


        //Genreating input fields from the model 
        if (model && Object.keys(model).length > 0) {

            const keys = Object.keys(model);
            keys.forEach(key => {
                let element = document.createElement("input");
                element.name = key.trim();
                element.value = model[key];
                form.appendChild(element);
            })
        }

        //Add form to DOM 
        document.body.appendChild(form);

        //Submit new created form in DOM
        form.submit();

        //Remove form from DOM
        var elem = document.getElementById(id);
        elem.parentNode.removeChild(elem);
    },

    isFieledDisabled(editMode, value, keepEnabled) {
        editMode = parseInt(editMode)
        return keepEnabled === 'true' || keepEnabled === true ? false : (editMode === EditModeEnum.Never || (editMode === EditModeEnum.Once && value))
    },

    flattenObject(obj) {
        if (obj == null) {
            return
        }
        return Object.keys(obj).reduce((acc, k) => {
            if (typeof obj[k] === 'object') Object.assign(acc, this.flattenObject(obj[k]));
            else acc[k] = obj[k];
            return acc;
        }, {})
    },
    objectRemoveEmpty(obj) {
        Object.keys(obj).forEach(function (key) {
            if (!obj[key] && typeof obj[key] !== 'number' && typeof obj[key] !== 'boolean') delete obj[key]
        });
        return obj;
    },

    // getUUID() {
    //     return LocalStorageService.get('uuid') || this.setUUID();
    // },

    generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    },

    // setUUID() {
    //     const uuid = this.generateUUID();
    //     LocalStorageService.set('uuid', uuid);
    //     return uuid;
    // },

    getErrorsObject(error) {
        if (error && error.errors) {
            if (error.code === ErrorType.INVALID_CAPTCHA) {
                return { 'Captcha': { name: 'Captcha', message: error.message } }
            } else {
                return error.errors.reduce((acc, el) => { acc[el.name] = el; return acc; }, {})
            }
        }
        return {};
    },
    checkTime(i) {
        if (i < 10) {
            i = '0' + i;
        }
        return i;
    },

    formatSecondsForCountdown(i) {
        let minutes = parseInt(i / 60, 10);
        let seconds = parseInt(i % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        return minutes + ":" + seconds;
    },


    isGameUrl() {
        const path = window.location.pathname;
        return path.includes('game') || path.includes('global-bet') || path.includes('betradar');
    },


    getRelativeUrl(url) {
        const popup = url.indexOf('/popup/') === 0;
        return popup ? '/promotions' + url : url;
    },

    nFormatter(num, digits) {
        var si = [
            { value: 1, symbol: "" },
            { value: 1E3, symbol: "k" },
            { value: 1E6, symbol: "M" },
            { value: 1E9, symbol: "G" },
            { value: 1E12, symbol: "T" },
            { value: 1E15, symbol: "P" },
            { value: 1E18, symbol: "E" }
        ];
        var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        var i;
        for (i = si.length - 1; i > 0; i--) {
            if (num >= si[i].value) {
                break;
            }
        }
        return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
    },


    getElementComputedWidth(element) {
        const style = element.currentStyle || window.getComputedStyle(element),
            width = element.offsetWidth, // or use style.width
            margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight),
            padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight),
            border = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
        return width + margin - padding + border;
    },
    findNestedObj(entireObj, keyToFind, valuesToFind) {
        let foundObj;
        JSON.stringify(entireObj, (_, nestedValue) => {
            if (nestedValue && valuesToFind.includes(nestedValue[keyToFind])) {
                foundObj = nestedValue;
            }
            return nestedValue;
        });
        return foundObj;
    },
    checkUrlMatch(url) {
        const pathName = window.location.pathname.replace(/\/$/, "");

        return url && ((url !== '/' && (pathName === '/' + LanguageService.getSelectedLanguage() + url.replace(/\/$/, "") || pathName.indexOf('/' + LanguageService.getSelectedLanguage() + (url?.endsWith('/') ? url.slice(0, -1) : url)) === 0
            || pathName.indexOf('/' + LanguageService.getSelectedLanguage() + (url + '/').replace(/\/$/, "") + '/') === 0)) || `${url}${LanguageService.getSelectedLanguage()}` === pathName)
    },

    debounce(func, wait) {
        let timeout;
        return function (...args) {
            const context = this;
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                timeout = null;
                func.apply(context, args);
            }, wait);
        };
    },

    findControlSection: (rootControl, name) => {
        if (!rootControl) {
            return null;
        }

        if (rootControl.name === name) {
            return rootControl;
        } else if (rootControl.nestedControls) {

            let result = null;
            for (let i = 0; i <= rootControl.nestedControls.length; i++) {
                if (rootControl.nestedControls[i]) {
                    result = Utils.findControlSection(rootControl.nestedControls[i], name);
                    if (result)
                        break;
                }
            }
            return result;
        }
    },

    getHeaderHeight() {
        let mobileHeaderHeight = document.getElementsByClassName("header-block")[0]?.clientHeight; //56;
        let infoBlockHeight = document.getElementsByClassName("tb--information-block")[0]?.clientHeight;
        mobileHeaderHeight = mobileHeaderHeight ? mobileHeaderHeight : 0;
        infoBlockHeight = infoBlockHeight ? infoBlockHeight : 0;
        return mobileHeaderHeight + infoBlockHeight;
    },

    isRTL() {
        const farsiLanguages = ['fa', 'ar', 'ku', 'he', 'ur-PK', 'aeb'];
        return LanguageService && farsiLanguages.indexOf(LanguageService.getSelectedLanguage()) !== -1;
    },

    importMomentLanguages: async (lang) => {

        lang = LanguageService.getMomentLanguage(lang);

        var available = ['af', 'ar-dz', 'ar-kw', 'ar-ly', 'ar-ma', 'ar-sa', 'ar-tn', 'ar', 'az', 'be',
            'bg', 'bm', 'bn', 'bo', 'br', 'bs', 'ca', 'cs', 'cv', 'cy', 'da', 'de-at', 'de-ch', 'de', 'dv', 'el',
            'en-au', 'en-ca', 'en-gb', 'en-ie', 'en-il', 'en-nz', 'en-SG', 'eo', 'es-do', 'es-us', 'es', 'et', 'eu',
            'fa', 'fi', 'fo', 'fr-ca', 'fr-ch', 'fr', 'fy', 'ga', 'gd', 'gl', 'gom-latn', 'gu', 'he', 'hi', 'hr', 'hu',
            'hy-am', 'id', 'is', 'it-ch', 'it', 'ja', 'jv', 'ka', 'kk', 'km', 'kn', 'ko', 'ku', 'ky', 'lb', 'lo', 'lt', 'lv',
            'me', 'mi', 'mk', 'ml', 'mn', 'mr', 'ms-my', 'ms', 'mt', 'my', 'nb', 'ne', 'nl-be', 'nl', 'nn', 'pa-in', 'pl', 'pt-br',
            'pt', 'ro', 'ru', 'sd', 'se', 'si', 'sk', 'sl', 'sq', 'sr-cyrl', 'sr', 'ss', 'sv', 'sw', 'ta', 'te', 'tet', 'tg', 'th',
            'tl-ph', 'tlh', 'tr', 'tzl', 'tzm-latn', 'tzm', 'ug-cn', 'uk', 'ur', 'uz-latn', 'uz', 'vi', 'x-pseudo', 'yo', 'zh-cn',
            'zh-hk', 'zh-tw'];
        return available.indexOf(lang) >= 0 ? import(`moment/locale/${lang}`) : null;
    },

    getBackgroudStyle(background, value) {
        return background ? Utils.isGradient(value) ? { backgroundImage: value } : { backgroundColor: value } : { backgroundColor: 'transparent', backgroundImage: 'none' };
    },

    isGradient(value) {
        return value && value.indexOf('gradient') >= 0;
    },

    getControlBySection(controls, controlName) {
        if (controls) {
            for (let i = 0; i < controls.length; i++) {
                const control = controls[i];
                if (control.name === controlName) {
                    return control;
                }
                if (control.name && control.name.indexOf("Container") !== -1) {
                    const result = Utils.getControlBySection(control.nestedControls, controlName)
                    if (result) {
                        return result;
                    }
                }
            }
        }
    },
    formattRounding(number, dec, symbol = '.') {
        const str = `${number}`
        return dec ? `${str.slice(0, str.length - dec)}${symbol}${str.slice(-dec)}` : str;
    },
    stripTags(str, allowedArray = []) {

        let key = '', allowed = false;
        let matches = [];
        let allowedTag = '';
        let i = 0;
        let k = '';
        let html = '';
        let replacer = function (search, replace, str) {
            return str.split(search).join(replace);
        };

        str += '';
        // Match tags
        matches = str.match(/(<\/?[\S][^>]*>)/gi);
        // Go through all HTML tags
        for (key in matches) {
            // Save HTML tag
            html = matches[key].toString();
            // Is tag not in allowed list? Remove from str!
            allowed = false;
            // Go through all allowed tags
            for (k in allowedArray) {     // Init
                allowedTag = allowedArray[k];
                i = -1;
                if (i != 0) { i = html.toLowerCase().indexOf('<' + allowedTag + '>'); }
                if (i != 0) { i = html.toLowerCase().indexOf('<' + allowedTag + ' '); }
                if (i != 0) { i = html.toLowerCase().indexOf('</' + allowedTag); }

                // Determine
                if (i == 0) {
                    allowed = true;
                    break;
                }
            }
            if (!allowed) {
                str = replacer(html, "", str); // Custom replace. No regexing
            }
        }
        return str.replace(/style=("|\')(.*?)("|\')/g, "");
    },
    getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
    },
    camelCase(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
            if (+match === 0) return "";
            return index === 0 ? match.toLowerCase() : match.toUpperCase();
        });
    },

    refreshMobilePage(action, redUrl, newTab) {
        let redirectUrl = window.location.href;
        if (window.location.href.indexOf(`?action=${action}`) === -1) {
            redirectUrl = Browser.addParamToUrl("action", action, window.location.href + (window.location.href.endsWith("/") ? '' : '/'));
            if (redUrl) {
                redirectUrl = Browser.addParamToUrl("redirectUrl", redUrl, redirectUrl);
            }
        }
        if (newTab) {
            window.open(redirectUrl, '_blank')
        } else {
            window.location.replace(redirectUrl);
        }
    },

    openMobilePage(action, payload) {
        if (payload) {
            action = `${action}?${Browser.generateQueryStringFromObject(payload)}`;
        }

        window.open(action, '_blank')
    },

    mobilePopupHandle(tab, tabObj, action) {
        if (Browser.isMobNativeApp()) {
            switch (tab) {
                case PopupEnum.Login:
                    Utils.openMobilePage(MobileRoutesEnum.Login);
                    break;
                case PopupEnum.Cashier:
                    if (tabObj?.subTab === DepositEnum.Methods) {
                        Utils.openMobilePage(MobileRoutesEnum.Cashier);
                    }
                    break;
                case PopupEnum.Registration:
                    Utils.openMobilePage(MobileRoutesEnum.Register);
                    break;

                case PopupEnum.Offers:
                    if (tabObj?.subTab === NewOfferMenuEnum.Sport) {
                        Utils.openMobilePage(MobileRoutesEnum.SportBonus);
                    }
                    if (tabObj?.subTab === NewOfferMenuEnum.Casino) {
                        Utils.openMobilePage(MobileRoutesEnum.CasinoBonus);
                    }
                    break;
                default:
                    if (action) {
                        Utils.openMobilePage(action);
                    }
                    break;
            }
        }
    },

    onLogoutRefresh(addLogoutAction) {
        if (Browser.isMobileApp() && addLogoutAction) {
            Utils.refreshMobilePage("logout");
        } else {
            window.location.reload();
        }
    },
    capitalize(s) {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
    },
    lowarcase(s) {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toLowerCase() + s.slice(1)
    },
    stripHtml(data, removeContentOfTags = ['title', 'style', 'script'], removeEntities = true) {
        if (typeof data !== 'string') return '';
        let tagsRegExp = Array.isArray(removeContentOfTags) && removeContentOfTags.length ? removeContentOfTags.reduce((a, b, i) => {
            return i === 1 ? `(<${a}.*>[\\w\\W]*?<\/${a}>)|(<${b}.*>[\\w\\W]*?<\/${b}>)|` : `${a}(<${b}.*>[\\w\\W]*?<\/${b}>)|`
        }) : '';
        let entityRegExp = removeEntities ? `|(&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});)` : '';
        let regularExpression = new RegExp(`${tagsRegExp}(<!--.*?-->)|(<!--[\\S\\s]+?-->)|(<!--[\\S\\s]*?$)|((<([^>]+)>)|(\\r\\n|\\n|\\r))${entityRegExp}`, 'gm');

        return data.replace(regularExpression, '').replace(/\s\s+/g, ' ').trim();
    },
    b64EncodeUnicode(str) {
        // first we use encodeURIComponent to get percent-encoded UTF-8,
        // then we convert the percent encodings into raw bytes which
        // can be fed into btoa.
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
                return String.fromCharCode('0x' + p1);
            }));
    },

    b64DecodeUnicode(str) {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(atob(str).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    },
    getElementOffsetTop(el) {
        const rect = el.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return Utils.documentHeight() - rect.top - scrollTop;
    },
    documentHeight() {
        var body = document.body,
            html = document.documentElement;
        return Math.max(body.scrollHeight, body.offsetHeight,
            html.clientHeight, html.scrollHeight, html.offsetHeight);
    },
    debounceForToggle(func, wait) {
        let timeout;
        return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    },
    getRandomChoice(array) {
        const randomIndex = Math.floor(Math.random() * array.length);
        return array[randomIndex];
    },


    isLanguageInPath(path, language) {
        if (path === RoutePath.METRA)
            return true;
        return path.indexOf('/' + language + '/') > -1 || path.indexOf('/' + language + '?') > -1 || path === '/' + language
    },
    checkRouteMatch(path, routeList) {
        return routeList.some(route => {
            const routePattern = route.replace(/:\w+/g, '([^/]+)');
            const regex = new RegExp(`^${routePattern}$`);
            return regex.test(path) || (!path.endsWith('/') ? regex.test(path + '/') : regex.test(path.replace(/.$/, '')));
        });
    },
    isObjectNullish(obj) {
        return Object.values(obj).every(prop => prop === null);
    },
    objectContainTrue(obj) {
        return Object.values(obj).find(prop => prop === true);
    },
    containsTruthyValue(obj, excludeProps = []) {
        if (!obj || typeof obj !== 'object') {
            return Boolean(obj);
        }
    
        return Object.entries(obj).some(([key, val]) => {
            if (excludeProps.includes(key)) {
                return false;
            }
    
            if (val && typeof val === 'object') {
                if (excludeProps.includes(`${key}.*`)) { // asterisk checks propertys existence
                    return false;
                }
                
                return Utils.containsTruthyValue(val, excludeProps.map(prop => {
                    if (prop.startsWith(`${key}.`)) {
                        return prop.slice(key.length + 1);
                    }
                    return prop;
                }));
            }
    
            return Boolean(val);
        });
    },
    apiCallQueue() {
        let queue = [];
        let isProcessing = false;

        async function processQueue() {
            isProcessing = true;
            while (queue.length > 0) {
                const currentCall = queue.shift();
                try {
                    await currentCall();
                } catch (error) {
                    console.error(error);
                }
            }
            isProcessing = false;
        }
        return {
            enqueue(call) {
                queue.push(call);
                if (!isProcessing) {
                    processQueue();
                }
            }
        };
    },
    async copyToClipboard(text) {
        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(text);
            } else {
                const el = document.createElement('textarea');
                el.value = text;
                document.body.appendChild(el);
                el.focus();
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
            }
        } catch (error) {
            console.error(error);
        }
    },
    secondsToTime(e, bShowHour) {
        const h = Math.floor(e / 3600),
            m = Math.floor(e % 3600 / 60),
            s = Math.floor(e % 60).toString().padStart(2, '0');

        return bShowHour ? h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0') + ':' + s : (h * 60 + m).toString().padStart(2, '0') + ':' + s;
    }

}

export default Utils